import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  connect() {
    App.afterTimeLog = (App.afterTimeLog || []).concat([this.updateProjectCardTime.bind(this)]);
  }

  updateProjectCardTime({ project_id }) {
    if (project_id) {
      const card = this.element.querySelector(`#project-${project_id}`);
      if (card && this.cardURL) {
        xhrRequest(this.cardURL.replace('PROJECT_ID', project_id), 'get').then(({ data }) => {
          card.parentNode.replaceChild(document.createElementFromString(data), card);
        });
      }
    }
  }

  get cardURL() {
    return this.data.get('card-url');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/projects/project-grid-controller.js